<template>
  <div>
    <el-dialog
      title="文件夹下载"
      :visible.sync="dialog"
      width="800px"
      top="50px"
      :modal="true"
      append-to-body
      :destroy-on-close="true"
      @close="onClose">
      <el-table
        v-loading="tableLoading"
        height="60vh"
        :data="tableData"
        :row-style="rowStyle()"
        :header-cell-style="headerCellStyle()"
        border>
        <el-table-column type="index" label="序号" align="center" width="55" :index="indexMethod"/>
        <el-table-column prop="fileName" label="文件夹名称" align="center"></el-table-column>
        <el-table-column prop="createTime" label="下载时间" align="center" min-width="160"></el-table-column>
        <el-table-column prop="protectName" label="执行状态" align="center">
          <template slot-scope="{row}">
            <span v-if="row.downLoadStatus === 0">进行中</span>
            <span v-if="row.downLoadStatus === 1">已完成</span>
            <span v-if="row.downLoadStatus === 2">取消</span>
            <span v-if="row.downLoadStatus === 3">失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="protectName" label="操作" align="center" min-width="120">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.downLoadStatus === 0"
              type="text"
              :disabled="booLock"
              @click="handleCancel(scope.row)">取消
            </el-button>
            <el-button
              v-if="scope.row.downLoadStatus === 1"
              type="text"
              :loading="scope.row.booDownload"
              @click="handledownloadFile(scope.row)">下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page="page"
          :page-size="page_size"
          :page-sizes="[10, 20, 100, 200, 300, 400]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import page from '@/mixin/page'
import downloadExcel from '@/mixin/downloadExcel'

export default {
  mixins: [page, downloadExcel],
  props: {
    value: {
      type: Boolean,
      default: true
    },
    exData: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      dialog: !!this.value,
      booLock: false,
      searchForm: {},
      tableLoading: false,
      tableData: [],
      tableUrl: '/api/file-cloud/fileFolderDownLoad/pageList'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    onClose() {
      this.$store.commit('uploadStore/SET_FOLDERDOWNLOADDIALOG', {
        show: false,
        exData: {}
      })
    },
    initCallBack() {
      this.tableData = this.tableData.map(item => {
        return {
          ...item,
          booDownload: false
        }
      })
    },
    async handleCancel(row) {
      this.booLock = true

      const res = await this.$fetch('/api/file-cloud/fileFolderDownLoad/cancel?folderId=' + row.folderId, {})
      if (res.code === 20000) {
        this.init()
      }
      this.booLock = false
    },
    async handledownloadFile(row) {
      if (row.booDownload) {
        return
      }

      try {
        row.booDownload = true

        await this.downloadFile({
          url: '/api/file-cloud/down_load/package',
          filename: row.fileName + '.zip',
          searchForm: {
            folderId: row.folderId
          }
        })
      } catch (err) {
      }

      row.booDownload = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {

  .el-dialog__body {
    padding: 30px 20px 0;
  }
}
</style>
